/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Ruian_CodeInputs */

const cs_form_ruian_code = /** @type {(inputs: Form_Ruian_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód RÚIAN`)
};

const en_form_ruian_code = /** @type {(inputs: Form_Ruian_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN code`)
};

/**
* | output |
* | --- |
* | "RÚIAN code" |
*
* @param {Form_Ruian_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_ruian_code = /** @type {((inputs?: Form_Ruian_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Ruian_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_ruian_code(inputs)
	return cs_form_ruian_code(inputs)
});